// import React, { useEffect, useState, useRef } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
// import { useParams } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import SignatureCanvas from "react-signature-canvas";
// import trainer from "../assets/trainer.png";
// import logo from "../assets/logo.png";

// // Importing Modal from react-bootstrap
// import { Modal, Button } from "react-bootstrap";
// import userEvent from "@testing-library/user-event";

// const ViewTrainingQuestions = () => {
//     const { trainingId } = useParams();
//     const [questions, setQuestions] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [userAnswers, setUserAnswers] = useState({});
//     const [quizTaken, setQuizTaken] = useState(false);
//     const [score, setScore] = useState(null);
//     const [signature, setSignature] = useState("");
//     const [trainingName, setTrainingName] = useState("");
//     const [trainingType, setTrainingType] = useState(""); // true_false or mcq
//     const [showResultModal, setShowResultModal] = useState(false); // Modal state
//     const [resultStatus, setResultStatus] = useState(""); // Pass/Fail status
//     const [resultColor, setResultColor] = useState(""); // Color for pass/fail
//     const [retake, setRetake] = useState("");
//     const [completionDate, setCompletionDate] = useState("");
//     const signaturePadRef = useRef(null);
//     const currentUser = auth.currentUser;
//     const [courseDate, setCourseDate] = useState("");
//     const [courseDate1, setCourseDate1] = useState("");


//     const todayDate = new Date().toLocaleDateString();

//     useEffect(() => {

//         document.title = `${trainingName} - Bee's Care Online Training Program`;

//         const fetchQuestions = async () => {
//             setLoading(true);
//             try {
//                 const querySnapshot = await getDocs(
//                     collection(db, `trainings/${trainingId}/questions`)
//                 );
//                 const questionsData = querySnapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     ...doc.data(),
//                 }));
//                 setQuestions(questionsData);
//             } catch (error) {
//                 toast.error("Error fetching questions: " + error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         const fetchTrainingDetails = async () => {
//             try {
//                 const trainingDoc = await getDoc(doc(db, "trainings", trainingId));
//                 if (trainingDoc.exists()) {
//                     setTrainingName(trainingDoc.data().name);
//                     setTrainingType(trainingDoc.data().type); // Fetch training type (true_false or mcq)
//                 } else {
//                     toast.error("Training not found!");
//                 }
//             } catch (error) {
//                 toast.error("Error fetching training details: " + error.message);
//             }

//         };

//         const checkIfQuizTaken = async () => {
//             if (currentUser) {
//                 const userQuizDocRef = doc(
//                     db,
//                     "users",
//                     currentUser.uid,
//                     "quizzes",
//                     trainingId
//                 );
//                 const docSnap = await getDoc(userQuizDocRef);
//                 if (docSnap.exists()) {
//                     setQuizTaken(true);
//                     const userQuizData = docSnap.data();
//                     setScore(userQuizData.score);
//                     setUserAnswers(userQuizData.answers);
//                     setSignature(userQuizData.signature);
//                     setRetake(userQuizData.retake)

//                     const completedAt = userQuizData.completedAt;
//                     if (completedAt) {
//                         // If the date is in the format yyyy-mm-dd (string), format it as dd/mm/yyyy
//                         const dateParts = completedAt.split("-"); // Split by the dash
//                         const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`; // Rearrange to dd/mm/yyyy
//                         setCompletionDate(formattedDate); // Update state with formatted date
//                     }


//                 }
//             }
//         };

//         fetchQuestions();
//         fetchTrainingDetails();
//         checkIfQuizTaken();
//     }, [trainingId, currentUser]);

//     const handleAnswerChange = (questionId, answer) => {
//         setUserAnswers((prevAnswers) => ({
//             ...prevAnswers,
//             [questionId]: answer,
//         }));
//     };

//     const handleClearSignature = () => {
//         signaturePadRef.current.clear();
//         setSignature("");
//     };

  
//     const handleSubmit = async () => {
//         if (!currentUser) {
//             toast.error("Please log in to submit the quiz.");
//             return;
//         }
    
//         if (Object.keys(userAnswers).length !== questions.length) {
//             toast.error("Please answer all questions.");
//             return;
//         }
    
//         if (signaturePadRef.current.isEmpty()) {
//             toast.error("Please provide your signature.");
//             return;
//         }
    
//         const dateInput1 = document.querySelector('input[type="date"]');
//         if (!dateInput1.checkValidity()) {
//             toast.error("Please select course date");
//             return;
//         }
    
//         const signatureData = signaturePadRef.current.toDataURL();
//         setSignature(signatureData);
    
//         let correctAnswers = 0;
//         questions.forEach((question) => {
//             if (trainingType === "true_false") {
//                 if (userAnswers[question.id] === question.answer) {
//                     correctAnswers++;
//                 }
//             } else if (trainingType === "mcq") {
//                 if (userAnswers[question.id] === question.correctOption) {
//                     correctAnswers++;
//                 }
//             }
//         });
    
//         setScore(correctAnswers);
    
//         // Determine pass/fail status
//         const passStatus = correctAnswers >= 15 ? "Pass" : "Fail";
//         const passColor = correctAnswers >= 15 ? "green" : "red";
//         setResultStatus(passStatus);
//         setResultColor(passColor);
    
//         let retakeStatusNew = correctAnswers >= 15 ? 0 : 1; // Initialize retakeStatus
//         let retakeStatus = retake + retakeStatusNew;
    
//         try {
//             const userQuizDocRef = doc(
//                 db,
//                 "users",
//                 currentUser.uid,
//                 "quizzes",
//                 trainingId
//             );
    
//             // Fetch the existing quiz data to check for attempts
//             const docSnap = await getDoc(userQuizDocRef);
    
//             let attempts = 1; // Default to 1 if no previous attempts
//             if (docSnap.exists()) {
//                 const userQuizData = docSnap.data();
//                 attempts = userQuizData.attempts ? userQuizData.attempts + 1 : 1;  // Increment attempts
//                 retakeStatus = userQuizData.retakeStatus ? userQuizData.retakeStatus + 1 : retakeStatus;  // Increment retake status if necessary
//             }
    
//             // Update only the attempts and retakeStatus fields in the quizzes collection
//             await updateDoc(userQuizDocRef, {
//                 attempts: attempts,
//                 retakeStatus: retakeStatus, // Update retakeStatus
//             });
    
//             // Save the detailed attempt data in the retakes collection
//             const retakeDocRef = doc(
//                 db,
//                 "users",
//                 currentUser.uid,
//                 "quizzes",
//                 trainingId,
//                 "retakes",
//                 trainingId
//             );
    
//             // Fetch existing retakes array or initialize it
//             const retakesSnap = await getDoc(retakeDocRef);
//             let retakesArray = [];
//             if (retakesSnap.exists()) {
//                 retakesArray = retakesSnap.data().attempts || [];
//             }
    
//             // Add new retake data to the array
//             const newRetakeData = {
//                 answers: userAnswers,
//                 score: correctAnswers,
//                 signature: signatureData,
//                 completedAt: dateInput1.value,
//                 trainingName: trainingName,
//             };
    
//             retakesArray.push(newRetakeData);
    
//             // Save the updated array of retakes in the retakes collection
//             await setDoc(retakeDocRef, {
//                 attempts: retakesArray,
//             });
    
//             setQuizTaken(true);
//             setShowResultModal(true); // Show the result modal
    
//             // Success toast
//             toast.success("Training quiz submitted successfully!");
    
//         } catch (error) {
//             toast.error("Error saving quiz: " + error.message);
//         }
//     };
    



//     // Handle the closing of the result modal
//     const handleCloseModal = () => setShowResultModal(false);

//     return (
//         <div className="container mt-3" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
//             <a href="/">Go Back</a>


//             <div className="text-center mb-4">
//                 <img className="logo-img" src={trainer} alt="Bee's Care Ltd" />
//                 <h2 className="mt-5">{trainingName} Question Paper</h2>
//             </div>

//             <div className="mb-3">
//                 <label><strong>Name of Learner:</strong></label>
//                 <input
//                     type="text"
//                     value={currentUser?.displayName || "Loading..."}
//                     className="form-control"
//                     readOnly
//                 />
//             </div>

//             <div className="mb-3">
//                 <label><strong>Organisation:</strong></label>
//                 <input type="text" value="Bee's Care Ltd" className="form-control" readOnly />
//             </div>

//             {retake >= 1 ? (<div className="mb-3">
//                 <label><strong>Course Date:</strong></label>
//                 <input type="date" value={courseDate1} className="form-control" onChange={(e) => setCourseDate1(e.target.value)} required />
//             </div>
//             ) : (
//                 <div className="mb-3">
//                     <label><strong>Course Date:</strong></label>
//                     <input type="text" value={completionDate} className="form-control" readOnly />
//                 </div>
//             )
//             }

//             <p className="text-center imp">
//                 <span className="imp-text">IMPORTANT:</span> Learners need to get at least 75% correct (15 correct answers) to gain their certificate.
//             </p>

//             {loading && <p>Loading questions...</p>}

//             {retake >= 1 ? (

//                 <form>
//                     <table className="table table-bordered">
//                         <thead>


//                             {trainingType === "true_false" ? (
//                                 <>
//                                     <tr style={{ backgroundColor: "#f5f5f5", textAlign: "center" }}>
//                                         <th>Question</th>
//                                         <th>True</th>
//                                         <th>False</th>
//                                     </tr>
//                                 </>
//                             ) : (
//                                 // <th>Options</th>
//                                 <></>
//                             )

//                             }

//                         </thead>

//                         <tbody>
//                             {questions.map((question) => (
//                                 // Render True/False questions inside the table
//                                 trainingType === "true_false" ? (
//                                     <tr key={question.id}>
//                                         <td>{question.text}</td>
//                                         <td
//                                             className="text-center clickable"
//                                             onClick={() => handleAnswerChange(question.id, true)}
//                                             style={{
//                                                 cursor: "pointer",
//                                                 backgroundColor: userAnswers[question.id] === true ? "#d3ffd3" : "transparent",
//                                             }}
//                                         >
//                                             {userAnswers[question.id] === true && (
//                                                 <span style={{ fontSize: "24px", color: "green" }}>X</span>
//                                             )}
//                                         </td>
//                                         <td
//                                             className="text-center clickable"
//                                             onClick={() => handleAnswerChange(question.id, false)}
//                                             style={{
//                                                 cursor: "pointer",
//                                                 backgroundColor: userAnswers[question.id] === false ? "#ffd3d3" : "transparent",
//                                             }}
//                                         >
//                                             {userAnswers[question.id] === false && (
//                                                 <span style={{ fontSize: "24px", color: "red" }}>X</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     // Render MCQs outside the table
//                                     <div key={question.id} className="question-container mcqs-class">
//                                         <div className="row">
//                                             <div className="col-12">
//                                                 <p><strong>{question.text}</strong></p>
//                                             </div>
//                                         </div>
//                                         {question.options.map((option, index) => (
//                                             <div
//                                                 key={index}
//                                                 className={`row option-container ${userAnswers[question.id] === index ? 'selected' : ''}`}
//                                                 style={{
//                                                     cursor: "pointer",
//                                                     backgroundColor: userAnswers[question.id] === index ? "#e0f7fa" : "transparent",
//                                                     padding: "10px",
//                                                     marginBottom: "5px",
//                                                     border: "1px solid #ccc",
//                                                     borderRadius: "4px",
//                                                 }}
//                                                 onClick={() => handleAnswerChange(question.id, index)}
//                                             >
//                                                 <div className="col-12">
//                                                     <p>{`${index + 1}. ${option}`}</p>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )
//                             ))}
//                         </tbody>
//                     </table>

//                     <div className="form-group">
//                         <p><strong>Signature By Learner:</strong></p>
//                         <SignatureCanvas
//                             ref={signaturePadRef}
//                             penColor="black"
//                             canvasProps={{
//                                 width: 500,
//                                 height: 200,
//                                 className: "signature-canvas",
//                                 style: { border: "1px solid #000", backgroundColor: "#fff" },
//                             }}
//                         />
//                         <button type="button" className="btn btn-secondary mt-2" onClick={handleClearSignature}>
//                             Clear Signature
//                         </button>
//                     </div>

//                     <button type="button" className="btn btn-primary mt-3" onClick={handleSubmit}>
//                         Submit Quiz
//                     </button>
//                 </form>

//             ) : (

//                 <div>
//                     <h3>Your Score: {score} / {questions.length}</h3>
//                     <p>Required Score for Passing: 15 / 20</p>

//                     <div className="mt-4">
//                         {questions.map((question, index) => (
//                             <div key={question.id} className={`question-container ${trainingType === "true_false" ? "true-false-class" : "mcqs-class"
//                                 }`}>
//                                 {/* Render header only once for True/False questions */}
//                                 {trainingType !== "true_false" && (
//                                     <div className="row">
//                                         <div className="col-8">
//                                             <p><strong>{question.text}</strong></p>
//                                         </div>
//                                         <div className="col-2 text-center">
//                                             <p><strong>Your Answer</strong></p>
//                                         </div>
//                                         <div className="col-2 text-center">
//                                             <p><strong>Correct Answer</strong></p>
//                                         </div>
//                                     </div>
//                                 )}


//                                 {trainingType === "true_false" && index === 0 && (
//                                     <div className="row">
//                                         <div className="col-8">
//                                             <p><strong>Statement</strong></p>
//                                         </div>
//                                         <div className="col-2 text-center">
//                                             <p><strong>Your Answer</strong></p>
//                                         </div>
//                                         <div className="col-2 text-center">
//                                             <p><strong>Correct Answer</strong></p>
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Render Multiple Choice Question if not True/False */}
//                                 {trainingType !== "true_false" && question.options && question.options.length > 0 &&
//                                     question.options.map((option, index) => {
//                                         const isUserAnswer = userAnswers[question.id] === index; // Check if user selected this option
//                                         const isCorrectAnswer = question.correctOption === index; // Check if this option is correct

//                                         return (
//                                             <div key={index} className="row">
//                                                 <div className={`col-8 ${isUserAnswer && !isCorrectAnswer ? 'text-danger' : ''}`}>
//                                                     <p>{index + 1}. {option}</p>
//                                                 </div>

//                                                 <div className="col-2 text-center">
//                                                     {/* Display X if this is the user's selected option */}
//                                                     {isUserAnswer ? (
//                                                         <span className={isCorrectAnswer ? "text-success" : "text-danger"}>X</span>
//                                                     ) : ""}
//                                                 </div>

//                                                 <div className="col-2 text-center">
//                                                     {/* Display X if this is the correct answer */}
//                                                     {isCorrectAnswer ? (
//                                                         <span className="text-success">X</span>
//                                                     ) : ""}
//                                                 </div>
//                                             </div>
//                                         );
//                                     })
//                                 }

//                                 {/* Render True/False Question as a Table */}

//                                 {trainingType === "true_false" && (
//                                     <div className="row">
//                                         {/* Question Text */}
//                                         <div
//                                             key={question.id}
//                                             className={`col-8 ${userAnswers[question.id] !== question.answer ? "text-danger" : ""
//                                                 }`}
//                                         >
//                                             {question.text}
//                                         </div>

//                                         {/* Your Answer */}
//                                         <div className="col-2 text-center">
//                                             {userAnswers[question.id] === true || userAnswers[question.id] === false ? (
//                                                 <span
//                                                     className={
//                                                         userAnswers[question.id] === question.answer
//                                                             ? "text-success" // Correct answer
//                                                             : "text-danger" // Incorrect answer
//                                                     }
//                                                 >
//                                                     {userAnswers[question.id] ? "True" : "False"}
//                                                 </span>
//                                             ) : (
//                                                 "Not answered"
//                                             )}
//                                         </div>

//                                         {/* Correct Answer */}
//                                         <div className="col-2 text-center">
//                                             <span className="text-success">
//                                                 {question.answer ? "True" : "False"}
//                                             </span>
//                                         </div>
//                                     </div>
//                                 )}


//                             </div>
//                         ))}


//                     </div>

//                     <p className="mt-5 ">
//                         <b>Candidate Signature</b>
//                     </p>
//                     <img className="mb-5" src={signature} alt="Signature" style={{ maxWidth: "300px", maxHeight: "150px" }} />

//                 </div>
//             )

//             }




//             {/* Modal for showing result status */}
//             <Modal show={showResultModal} onHide={handleCloseModal}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Quiz Result</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body style={{ color: resultColor, textAlign: "center" }}>
//                     <h3>{resultStatus}</h3>
//                     <p>Your Score: {score} / {questions.length}</p>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
//                 </Modal.Footer>
//             </Modal>

//             <div className="text-center mt-4">
//                 <p><strong>© Trainer Courses Ltd</strong></p>
//             </div>


//             <ToastContainer />

//             <a href="/">Go Back</a>

//         </div>
//     );
// };

// export default ViewTrainingQuestions;












import React, { useEffect, useState, useRef } from "react";
import { db, auth } from "../firebase";
import { collection, getDocs, doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignatureCanvas from "react-signature-canvas";
import { Modal, Button } from "react-bootstrap";

const ViewTrainingQuestions = () => {
    const { trainingId } = useParams();
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userAnswers, setUserAnswers] = useState({}); // Holds current user answers
    const [quizTaken, setQuizTaken] = useState(false); // Tracks if the quiz has been taken
    const [score, setScore] = useState(null); // User's score
    const [signature, setSignature] = useState(""); // User's signature
    const [trainingName, setTrainingName] = useState(""); // Name of the training
    const [trainingType, setTrainingType] = useState(""); // true_false or mcq
    const [showResultModal, setShowResultModal] = useState(false); // Modal state
    const [resultStatus, setResultStatus] = useState(""); // Pass/Fail status
    const [resultColor, setResultColor] = useState(""); // Color for pass/fail
    const [retake, setRetake] = useState(0); // Number of retakes
    const [completionDate, setCompletionDate] = useState(""); // Date of completion
    const signaturePadRef = useRef(null); // Reference for the signature canvas
    const currentUser = auth.currentUser; // Current authenticated user
    const [courseDate, setCourseDate] = useState(""); // Course date for retakes

    useEffect(() => {
        document.title = `${trainingName} - Bee's Care Online Training Program`;

        const fetchQuestions = async () => {
            setLoading(true);
            try {
                const querySnapshot = await getDocs(collection(db, `trainings/${trainingId}/questions`));
                const questionsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setQuestions(questionsData);
            } catch (error) {
                toast.error("Error fetching questions: " + error.message);
            } finally {
                setLoading(false);
            }
        };

        const fetchTrainingDetails = async () => {
            try {
                const trainingDoc = await getDoc(doc(db, "trainings", trainingId));
                if (trainingDoc.exists()) {
                    setTrainingName(trainingDoc.data().name);
                    setTrainingType(trainingDoc.data().type); // Fetch training type (true_false or mcq)
                } else {
                    toast.error("Training not found!");
                }
            } catch (error) {
                toast.error("Error fetching training details: " + error.message);
            }
        };

        const checkIfQuizTaken = async () => {
            if (currentUser) {
                const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", trainingId);
                const docSnap = await getDoc(userQuizDocRef);
                if (docSnap.exists()) {
                    setQuizTaken(true);
                    const userQuizData = docSnap.data();
                    setScore(userQuizData.score);
                    setRetake(userQuizData.retake || 0);

                    // Only populate signature and completion date, not answers
                    setSignature(userQuizData.signature || "");
                    const completedAt = userQuizData.completedAt;
                    if (completedAt) {
                        const dateParts = completedAt.split("-");
                        const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
                        setCompletionDate(formattedDate);
                    }
                }
            }
        };

        fetchQuestions();
        fetchTrainingDetails();
        checkIfQuizTaken();
    }, [trainingId, currentUser]);

    const navigate = useNavigate();


    const handleAnswerChange = (questionId, answer) => {
        setUserAnswers((prevAnswers) => ({ ...prevAnswers, [questionId]: answer }));
    };

    const handleClearSignature = () => {
        signaturePadRef.current.clear();
        setSignature("");
    };

    const handleSubmit = async () => {
        if (!currentUser) {
            toast.error("Please log in to submit the quiz.");
            return;
        }

        if (Object.keys(userAnswers).length !== questions.length) {
            toast.error("Please answer all questions.");
            return;
        }

        if (signaturePadRef.current.isEmpty()) {
            toast.error("Please provide your signature.");
            return;
        }

        const dateInput = document.querySelector('input[type="date"]');
        if (!dateInput?.checkValidity()) {
            toast.error("Please select a valid course date.");
            return;
        }

        const signatureData = signaturePadRef.current.toDataURL();
        setSignature(signatureData);

        let correctAnswers = 0;
        questions.forEach((question) => {
            if (trainingType === "true_false") {
                if (userAnswers[question.id] === question.answer) correctAnswers++;
            } else if (trainingType === "mcq") {
                if (userAnswers[question.id] === question.correctOption) correctAnswers++;
            }
        });

        setScore(correctAnswers);

        // Determine pass/fail status
        const passStatus = correctAnswers >= 15 ? "Pass" : "Fail";
        const passColor = correctAnswers >= 15 ? "green" : "red";
        setResultStatus(passStatus);
        setResultColor(passColor);

        let retakeStatusNew = correctAnswers >= 15 ? 0 : 1;
        let retakeStatus = retake + retakeStatusNew;

        try {
            const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", trainingId);
            const docSnap = await getDoc(userQuizDocRef);

            let attempts = 1;
            if (docSnap.exists()) {
                const userQuizData = docSnap.data();
                attempts = userQuizData.attempts ? userQuizData.attempts + 1 : 1;
                retakeStatus = userQuizData.retakeStatus ? userQuizData.retakeStatus + 1 : retakeStatus;
            }

            await updateDoc(userQuizDocRef, {
                attempts,
                retakeStatus,
            });

            const retakeDocRef = doc(db, "users", currentUser.uid, "quizzes", trainingId, "retakes", trainingId);
            const retakesSnap = await getDoc(retakeDocRef);
            let retakesArray = [];
            if (retakesSnap.exists()) {
                retakesArray = retakesSnap.data().attempts || [];
            }

            const newRetakeData = {
                answers: userAnswers,
                score: correctAnswers,
                signature: signatureData,
                completedAt: dateInput.value,
                trainingName,
            };

            retakesArray.push(newRetakeData);
            await setDoc(retakeDocRef, { attempts: retakesArray });

            setQuizTaken(true);
            setShowResultModal(true);
            toast.success("Training quiz submitted successfully!");

            setTimeout(() => {
                navigate("/");
            }, 2000);
            
        } catch (error) {
            toast.error("Error saving quiz: " + error.message);
        }
    };

    const handleCloseModal = () => setShowResultModal(false);

    return (
        <div className="container mt-3" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
            <a href="/">Go Back</a>

            <div className="text-center mb-4">
                <h2 className="mt-5">{trainingName} Question Paper</h2>
            </div>

            <div className="mb-3">
                <label><strong>Name of Learner:</strong></label>
                <input type="text" value={currentUser?.displayName || "Loading..."} className="form-control" readOnly />
            </div>

            <div className="mb-3">
                <label><strong>Organisation:</strong></label>
                <input type="text" value="Bee's Care Ltd" className="form-control" readOnly />
            </div>

            {retake >= 1 ? (
                <div className="mb-3">
                    <label><strong>Course Date:</strong></label>
                    <input type="date" value={courseDate} className="form-control" onChange={(e) => setCourseDate(e.target.value)} required />
                </div>
            ) : (
                <div className="mb-3">
                    <label><strong>Course Date:</strong></label>
                    <input type="text" value={completionDate} className="form-control" readOnly />
                </div>
            )}

            <p className="text-center imp">
                <span className="imp-text">IMPORTANT:</span> Learners need to get at least 75% correct (15 correct answers) to gain their certificate.
            </p>

            {loading && <p>Loading questions...</p>}

            {retake >= 1 ? (
                <form>
                    <table className="table table-bordered">
                        <thead>
                            {trainingType === "true_false" && (
                                <tr style={{ backgroundColor: "#f5f5f5", textAlign: "center" }}>
                                    <th>Question</th>
                                    <th>True</th>
                                    <th>False</th>
                                </tr>
                            )}
                        </thead>
                        <tbody>
                            {questions.map((question) => (
                                trainingType === "true_false" ? (
                                    <tr key={question.id}>
                                        <td>{question.text}</td>
                                        <td
                                            className="text-center clickable"
                                            onClick={() => handleAnswerChange(question.id, true)}
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor: userAnswers[question.id] === true ? "#d3ffd3" : "transparent",
                                            }}
                                        >
                                            {userAnswers[question.id] === true && <span style={{ fontSize: "24px", color: "green" }}>X</span>}
                                        </td>
                                        <td
                                            className="text-center clickable"
                                            onClick={() => handleAnswerChange(question.id, false)}
                                            style={{
                                                cursor: "pointer",
                                                backgroundColor: userAnswers[question.id] === false ? "#ffd3d3" : "transparent",
                                            }}
                                        >
                                            {userAnswers[question.id] === false && <span style={{ fontSize: "24px", color: "red" }}>X</span>}
                                        </td>
                                    </tr>
                                 ) :  trainingType === "mcq" ? (
                                    <div key={question.id} className="question-container mcqs-class">
                                        <div className="row">
                                            <div className="col-12">
                                                <p><strong>{question.text}</strong></p>
                                            </div>
                                        </div>
                                        {question.options.map((option, index) => (
                                            <div
                                                key={index}
                                                className={`row option-container ${userAnswers[question.id] === index ? 'selected' : ''}`}
                                                style={{
                                                    cursor: "pointer",
                                                    backgroundColor: userAnswers[question.id] === index ? "#e0f7fa" : "transparent",
                                                    padding: "10px",
                                                    marginBottom: "5px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                                onClick={() => handleAnswerChange(question.id, index)}
                                            >
                                                <div className="col-12">
                                                    <p>{`${index + 1}. ${option}`}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ):(<></>)
                            ))}
                        </tbody>
                    </table>

                    <div className="form-group">
                        <p><strong>Signature By Learner:</strong></p>
                        <SignatureCanvas
                            ref={signaturePadRef}
                            penColor="black"
                            canvasProps={{
                                width: 500,
                                height: 200,
                                className: "signature-canvas",
                                style: { border: "1px solid #000", backgroundColor: "#fff" },
                            }}
                        />
                        <button type="button" className="btn btn-secondary mt-2" onClick={handleClearSignature}>
                            Clear Signature
                        </button>
                    </div>

                    <button type="button" className="btn btn-primary mt-3" onClick={handleSubmit}>
                        Submit Quiz
                    </button>
                </form>
            ) : (
                <div>
                    <h3>Your Score: {score} / {questions.length}</h3>
                    <p>Required Score for Passing: 15 / 20</p>

                    <div className="mt-4">
                        {questions.map((question, index) => (
                            <div key={question.id} className={`question-container ${trainingType === "true_false" ? "true-false-class" : "mcqs-class"}`}>
                                {trainingType === "true_false" && index === 0 && (
                                    <div className="row">
                                        <div className="col-8">
                                            <p><strong>Statement</strong></p>
                                        </div>
                                        <div className="col-2 text-center">
                                            <p><strong>Your Answer</strong></p>
                                        </div>
                                        <div className="col-2 text-center">
                                            <p><strong>Correct Answer</strong></p>
                                        </div>
                                    </div>
                                )}

                                {trainingType === "true_false" ? (
                                    <div className="row">
                                        <div className={`col-8 ${userAnswers[question.id] !== question.answer ? "text-danger" : ""}`}>
                                            {question.text}
                                        </div>
                                        <div className="col-2 text-center">
                                            {userAnswers[question.id] === true || userAnswers[question.id] === false ? (
                                                <span className={userAnswers[question.id] === question.answer ? "text-success" : "text-danger"}>
                                                    {userAnswers[question.id] ? "True" : "False"}
                                                </span>
                                            ) : (
                                                "Not answered"
                                            )}
                                        </div>
                                        <div className="col-2 text-center">
                                            <span className="text-success">{question.answer ? "True" : "False"}</span>
                                        </div>
                                    </div>
                                ) : (
                                    question.options.map((option, index) => {
                                        const isUserAnswer = userAnswers[question.id] === index;
                                        const isCorrectAnswer = question.correctOption === index;

                                        return (
                                            <div key={index} className="row">
                                                <div className={`col-8 ${isUserAnswer && !isCorrectAnswer ? 'text-danger' : ''}`}>
                                                    <p>{index + 1}. {option}</p>
                                                </div>
                                                <div className="col-2 text-center">
                                                    {isUserAnswer ? <span className={isCorrectAnswer ? "text-success" : "text-danger"}>X</span> : ""}
                                                </div>
                                                <div className="col-2 text-center">
                                                    {isCorrectAnswer ? <span className="text-success">X</span> : ""}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        ))}
                    </div>

                    <p className="mt-5"><b>Candidate Signature</b></p>
                    <img className="mb-5" src={signature} alt="Signature" style={{ maxWidth: "300px", maxHeight: "150px" }} />
                </div>
            )}

            <Modal show={showResultModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Quiz Result</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ color: resultColor, textAlign: "center" }}>
                    <h3>{resultStatus}</h3>
                    <p>Your Score: {score} / {questions.length}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                </Modal.Footer>
            </Modal>

            <div className="text-center mt-4">
                <p><strong>© Trainer Courses Ltd</strong></p>
            </div>

            <ToastContainer />
            <a href="/">Go Back</a>
        </div>
    );
};

export default ViewTrainingQuestions;